import { CollectionAssetToolbar as CollectionAssetToolbarComponent } from './collection-asset-toolbar';
import { CollectionAssetToolbarControl, CollectionAssetToolbarControls } from './collection-asset-toolbar';
import { CollectionAssetToolbarFilters } from './collection-asset-toolbar';
import type { CollectionAssetToolbarControlProps, CollectionAssetToolbarGroupProps } from './collection-asset-toolbar';
import type { CollectionAssetToolbarProps } from './collection-asset-toolbar';
import { CollectionAssetToolbarClassificationFilter } from './collection-asset-toolbar.classification-filter';
import type { CollectionAssetToolbarClassificationFilterProps } from './collection-asset-toolbar.classification-filter';
import { CollectionAssetToolbarFavoritesToggle } from './collection-asset-toolbar.favorites-toggle';
import type { CollectionAssetToolbarFavoritesToggleProps } from './collection-asset-toolbar.favorites-toggle';
import { CollectionAssetToolbarSort, type CollectionAssetToolbarSortProps } from './collection-asset-toolbar.sort';
import { CollectionAssetToolbarSparkToggle } from './collection-asset-toolbar.spark-toggle';
import type { CollectionAssetToolbarSparkToggleProps } from './collection-asset-toolbar.spark-toggle';

/**
 * Toolbar row above the collection asset grid, composed from slots so other features can add
 * controls without editing the toolbar itself.
 *
 * @example
 *  <CollectionAssetToolbar className="pb-8">
 *    <CollectionAssetToolbar.Filters>
 *      <CollectionAssetToolbar.ClassificationFilter {...classificationProps} />
 *      <CollectionAssetToolbar.SparkToggle {...sparkProps} />
 *      <CollectionAssetToolbar.FavoritesToggle {...favoritesProps} />
 *    </CollectionAssetToolbar.Filters>
 *    <CollectionAssetToolbar.Controls>
 *      <CollectionAssetToolbar.Control label="Attention maps:">{...}</CollectionAssetToolbar.Control>
 *      <CollectionAssetToolbar.Sort {...sortProps} />
 *    </CollectionAssetToolbar.Controls>
 *  </CollectionAssetToolbar>
 */
const CollectionAssetToolbar = Object.assign(CollectionAssetToolbarComponent, {
  Filters: CollectionAssetToolbarFilters,
  Controls: CollectionAssetToolbarControls,
  Control: CollectionAssetToolbarControl,
  ClassificationFilter: CollectionAssetToolbarClassificationFilter,
  SparkToggle: CollectionAssetToolbarSparkToggle,
  FavoritesToggle: CollectionAssetToolbarFavoritesToggle,
  Sort: CollectionAssetToolbarSort,
});

export { CollectionAssetToolbar };
export type { CollectionAssetToolbarProps, CollectionAssetToolbarGroupProps, CollectionAssetToolbarControlProps };
export type { CollectionAssetToolbarClassificationFilterProps, CollectionAssetToolbarSparkToggleProps };
export type { CollectionAssetToolbarFavoritesToggleProps, CollectionAssetToolbarSortProps };
